import {call, put, select} from "redux-saga/effects";
import {toast} from "react-toastify";
import {getCampaignBrands} from "../requests/brandService";
import {
  setLoading,
  updateFocusedItems,
  updateSpecialBrands,
  setSearchResult,
  setSearchItems, setInitialSearchData
} from "../../slices/searchSlice";
import {getCmsFocusedItems, getFocusedItem, getFocusedItems} from "../requests/focusedItemsService";
import {requestGetProductCampaign} from "../requests/focusItemService";
import {requestBannerPages} from "../requests/bannerService";
import {SEARCH_SELECT_BLOGS_TYPE, SEARCH_SELECT_TAGS_TYPE} from "../../../constants/commons";
import {getBlog, getSearchBlogs, getSearchedTags} from "../requests/blogService";
import { getPredictionCampaigns, getPredictionCampaignInfo, getPredictionCategoryInfo } from "../requests/predictionService";

export function* handleLoadBrandCampaign() {
  try {
    yield put(setLoading({type: 'specialBrands', loading: true}));
    const response = yield call(() => getCampaignBrands());
    yield put(updateSpecialBrands(response.data));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(updateSpecialBrands({error: errMsg}));
  }
}

export function* handleLoadFocusedItems() {
  try {
    yield put(setLoading({type: 'focusedItems', loading: true}));
    const response = yield call(() => getFocusedItems());
    yield put(updateFocusedItems(response.data));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(updateFocusedItems({error: errMsg}));
  }
}

export function* handleSearchFocusedItems(action) {
  const element = `fItems`;
  const {callback, query, type} = action.payload;

  if(!query.trim()){
    callback([])
  }

  const searchText = query.toLowerCase()

  try {
    const focusedItems = yield select((state) => state.search[element].data);
    const dataKey = `${searchText}-${type}`

    if(focusedItems[dataKey]){
      callback(focusedItems[dataKey])
    }else{
      yield put(setSearchItems({element, loading: true}));
      let response
      if(type === SEARCH_SELECT_TAGS_TYPE){
        const resp = yield call(() => getSearchedTags({searchText: query}));
        response = resp.data
      }else if(type === SEARCH_SELECT_BLOGS_TYPE){
        const resp = yield call(() => getSearchBlogs({searchText: query}));
        response = resp.data
      }else{
        response = yield call(() => getCmsFocusedItems({searchText: query, type}));
      }



      yield put(setSearchItems({element, data: response.data, searchText, type}));
      callback(response.data)
    }

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    // toast.error(`Error: ${errMsg}`);
    yield put(setSearchItems({element, error: errMsg}));
    callback([])
  }
}

export function* handleLoadInitialSearchData(action) {
  const {  id, type} = action.payload;
  const element = `${id}-${type}`
  try {
    yield put(setInitialSearchData({id: element, loading: true}));
    let resp
    if(type === SEARCH_SELECT_BLOGS_TYPE){
      const {data} = yield call(() => getBlog(id));
      resp = data;
    }else{
      const {data} = yield call(() => getFocusedItem(id));
      resp = data;
    }

    yield put(setInitialSearchData({data: resp, id: element}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setInitialSearchData({error: errMsg, id: element}));
  }
}



export function* handleLoadBannerTypes() {
  const type = "bannerTypes";
  try {
    yield put(setLoading({type, loading: true}));
    const {data} = yield call(() => requestBannerPages());
    yield put(setSearchResult({data: data.data, type}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(setSearchResult({error: errMsg, type}));
  }
}

export function* handleFetchProductCampaign(action) {
  const {payload: {type}} = action;
  try {
    yield put(setLoading({type, loading: true}));
    const {data} = yield call(() => requestGetProductCampaign(type));
    yield put(setSearchResult({data: data.jeevee_product_bundles, type}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setSearchResult({error: errMsg, type}));
  }
}

export function* handleLoadPredictionCampaign() {
  const type = 'predictionCampaigns'
  try {
    yield put(setLoading({type, loading: true}));
    const {data} = yield call(() => getPredictionCampaigns());
    yield put(setSearchResult({data: data.data, type}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(updateSpecialBrands({error: errMsg}));
  }
}

export function* handleLoadPredictionCategories(action) {
  const type = 'predictionCategories'
  try {
    yield put(setLoading({type, loading: true}));
    const {data} = yield call(() => getPredictionCategoryInfo(action.payload));
    yield put(setSearchResult({data: data.data, type}));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(`Error: ${errMsg}`);
    yield put(updateSpecialBrands({error: errMsg}));
  }
}
